<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		<!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
	
		<div class="mr-auto">
			<el-form inline ref="form" :model="searchform">
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
						    </el-date-picker>
					</el-form-item>
           <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.요율')" v-model="searchform.pc" size="mini" style="width:150px" ></el-input>
          </el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
	
			
    		
		</div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


      
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt1)}}</template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt2)}}</template>
      </el-table-column>

      

 <el-table-column
        :label="$t('msg.머니합계')" prop="mem_cash" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.mem_cash)}}</span></template>
      </el-table-column>
    

        <el-table-column
        :label="$t('msg.롤링합계')" prop="tt7" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('searchText.요율')" prop="pc" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.pc)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('searchText.죽장정산')" prop="jc" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.jc)}}</span></template>
      </el-table-column>

    

    


        
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
				
				
</div>
 </template>

 <script>
 
    export default {
      
    	data(){
    		return{
    			domain:window.sessionStorage.getItem('domain'),
          rosing:window.sessionStorage.getItem('rosing'),
          power:window.sessionStorage.getItem('power'),
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    			
    			searchform:{
    				  searchOptions:[
             
            {
              label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            },
           
            
            ],
           
            value:'',
    				time:[],
            keyword:'',
            pc:'',
    			


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        

    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			       
			         
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
    	
    			 // 搜索事件
			searchEvent(){

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
    		getList(){

    		 
               console.log(this.searchform.time) 
         

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/rosing?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword+'&pc='+this.searchform.pc;
    			
    
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                    this.loading =false
                     if(response.data.code !=200)
                            {
                               this.$message({
                                  message:response.data.msg,
                                  type: 'warning'
                                });
                                
                            }else{
                                let data = response.data.data
                                this.tableData =data
                            }
                    
               
            }).catch((error) =>{
            	

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }


</style>


// WEBPACK FOOTER //
// src/views/jang/list.vue